import CAxios from "../../Utils/CAxios";

export const toGetNplBrands = async () => {
  const { data } = await CAxios.get(`/api/neopartslink/brands`);
  return data.success && data.success.brands ? data.success.brands : {};
};

export const toOpenNplCatalogue = async (vin, brand, lang) => {
  const { data } = await CAxios.post(`/api/neopartslink/catalog/open`, {
    vin,
    brand,
    lang,
  });
  return data.success ? data.success : null;
};

export const toSelectNplItem = async (sessionId, id) => {
  const { data } = await CAxios.post(`/api/neopartslink/catalog/select`, {
    sessionId,
    id,
  });
  return data.success ? data.success : null;
};

export const toGetNplDiagram = async (apiUrl) => {
  let path = apiUrl || "";
  path = path.replace(/^https?:\/\/[^/]+/i, "");
  path = path.replace(/^\/+/, "");
  path = path.replace(/^api\/v\d+\//i, "");
  path = path.replace(/^files\//i, "");
  const { data } = await CAxios.get(`/api/neopartslink/files/${path}`, {
    responseType: "blob",
  });
  return URL.createObjectURL(data);
};

export const toServiceBoxVin = async (vin, lang, vehicleId) => {
  const body = { vin, lang };
  if (vehicleId) {
    body.vehicleId = vehicleId;
  }
  const { data } = await CAxios.post(`/api/neopartslink/servicebox/vin`, body);
  return data.success ? data.success : null;
};

export const toServiceBoxProducts = async (
  vehicleId,
  familyId,
  genartId,
  familyName,
  genartName,
  isUniversal,
) => {
  const { data } = await CAxios.post(
    `/api/neopartslink/servicebox/products`,
    {
      vehicleId,
      familyId,
      genartId,
      familyName,
      genartName,
      isUniversal,
    },
  );
  return data.success ? data.success : null;
};

export const toGetNplStock = async (search) => {
  const { data } = await CAxios.post(`/api/tecdoc/all`, {
    search,
    page: 1,
    brandId: "",
  });
  const articles = data.success && data.success.result ? data.success.result : [];
  const uniqueMap = new Map();
  articles.forEach((product) => {
    if (!uniqueMap.has(product.articleId)) {
      uniqueMap.set(product.articleId, product);
    }
  });
  return Array.from(uniqueMap.values());
};

export const toCompareNplSuppliers = async (reference) => {
  const { data } = await CAxios.post(`/api/neopartslink/suppliers/compare`, {
    reference,
  });
  return data.success ? data.success : null;
};

export const toGetNplHistory = async () => {
  const { data } = await CAxios.get(`/api/neopartslink/history`);
  return data.success && data.success.history ? data.success.history : [];
};

export const toAddNplHistory = async (vin, brand, lang) => {
  const { data } = await CAxios.post(`/api/neopartslink/history/add`, {
    vin,
    brand,
    lang,
  });
  return data.success ? data.success : null;
};

export const toUpdateNplHistoryOwner = async (id, owner) => {
  const { data } = await CAxios.post(`/api/neopartslink/history/update`, {
    id,
    owner,
  });
  return data.success ? data.success : null;
};

export const toDeleteNplHistory = async (id) => {
  const { data } = await CAxios.post(`/api/neopartslink/history/delete`, {
    id,
  });
  return data.success ? data.success : null;
};